import GraphicStandEditForm from './graphic-stand-edit-form';

export default GraphicStandEditForm;